import { useState } from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import leoraIcon from '../../assets/leoraIcon_black.png';
import { useAuth } from '../context/AuthContext';
import AdminSidebar from './AdminSidebar';
import { IconMenu } from './AdminIcons';

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="admin-shell">
      <div className="admin-layout">
        {sidebarOpen ? (
          <button
            type="button"
            className="admin-sidebar-backdrop"
            onClick={() => setSidebarOpen(false)}
            aria-label="Cerrar menú"
          />
        ) : null}
        <AdminSidebar
          open={sidebarOpen}
          onClose={() => setSidebarOpen(false)}
          user={user}
          onLogout={logout}
        />
        <div className="admin-main">
          <header className="admin-topbar">
            <button
              type="button"
              className="admin-btn admin-btn--icon admin-sidebar__toggle"
              onClick={() => setSidebarOpen((v) => !v)}
              aria-label="Abrir menú"
              aria-expanded={sidebarOpen}
            >
              <IconMenu />
            </button>
            <Link to="/leoradmin" className="admin-topbar__brand" aria-label="Inicio del admin">
              <img src={leoraIcon} alt="Leora" className="admin-topbar__logo" />
            </Link>
          </header>
          <main className="admin-content">
            <div key={location.pathname} className="admin-page-enter">
              <Outlet />
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}
